export const GoogleMapApiConfig = 'AIzaSyAGkrWW6F88zP1dHFVVwknfHv-o-NBal1U';